import { render } from "./SensorsDashboard.vue?vue&type=template&id=23a8acb7&scoped=true"
import script from "./SensorsDashboard.vue?vue&type=script&lang=js"
export * from "./SensorsDashboard.vue?vue&type=script&lang=js"

import "./SensorsDashboard.vue?vue&type=style&index=0&id=23a8acb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a8acb7"]])

export default __exports__